import {combineReducers} from "redux";

import {quotaLimitsReducer} from "modules/QuotaManager/services/QuotaLimits/reducer";
import {quotaTypesReducer} from "modules/QuotaManager/services/QuotaTypes/reducer";

export const quotaManagerReducer = combineReducers({
    quotaLimitsReducer: quotaLimitsReducer,
    quotaTypesReducer: quotaTypesReducer,
});
